import { useEffect, useState } from 'react'
import _ from 'lodash'
import { Input } from '@design-systems/canvas-ui'
import RFIQuestion from './RFIQuestion'
import {
  QUESTION_TYPE_UPLOAD,
  SECTION_INLINE_HEADER,
} from '../../common/commonConstants'

const RFI3QuestionWindow = (props) => {
  const [rfiAnswers, setRfiAnswers] = useState(null)

  //#region UseEffects

  useEffect(() => {
    if (!_.isEqual(rfiAnswers, props.rfiAnswers)) {
      setRfiAnswers(props.rfiAnswers)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rfiAnswers])

  useEffect(() => {
    if (rfiAnswers) {
      props.updateAnswer(rfiAnswers)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfiAnswers])

  //#endregion

  /**
   * RFI3 Answer is updated for any RFIQuestion inside this RFI3Quesiton Window
   * @param {*} answerObject
   */
  const updateRfiAnswer = (answerObject) => {
    //Find if answer node exists
    let newAnswerIndex = rfiAnswers.findIndex(
      (eachAnswerObject) => eachAnswerObject.uid === answerObject.uid,
    )
    if (newAnswerIndex === -1) {
      //New answer node
      setRfiAnswers([...rfiAnswers, answerObject])
    } else {
      let newAllAnswers = rfiAnswers.map((eachAnswerObject) => {
        return eachAnswerObject.uid === answerObject.uid
          ? answerObject
          : eachAnswerObject
      })
      setRfiAnswers(newAllAnswers)
    }
  }

  /**
   * Render all RFIQuestions inside this RFIQuestionWindow
   * @returns
   */
  const renderAllQuestions = () => {
    return props.sectionTemplate?.rfi3_questions.map(
      (eachRfiQuestion, questionIndex) => {
        let rfiAnswerDetail = rfiAnswers?.filter(
          (ans) => ans.uid === eachRfiQuestion.uid,
        )

        return (
          <RFIQuestion
            isReadOnly={props.isReadOnly}
            key={`rfi-question-${questionIndex}`}
            questionDetail={eachRfiQuestion}
            answerDetails={rfiAnswerDetail ? rfiAnswerDetail[0] : null}
            rfiMasterData={props.rfiMasterData}
            questionNumber={questionIndex}
            updateAnswer={(answerObject) => updateRfiAnswer(answerObject)}
            supplierId={props.supplierId}
            locationId={props.locationId}
            manufacturingTypeId={props.manufacturingTypeId}
            rfi3Files={props.rfi3Files}
            updateRfi3Files={(newRfi3Files) =>
              props.updateRfiFiles(newRfi3Files?.uploaded_files)
            }
            errorCacheControl={props.errorCache?.controls}
          />
        )
      },
    )
  }

  return (
    <div>
      <Input.Label className="hc8-fs-050 font-weight-500">
        {props.sectionTemplate?.uid?.toLowerCase() === 'gateway_decision' ? (
          <span>Question (Optional)</span>
        ) : (
          <span>
            Questions Answered -{' '}
            {props.rfiAnswers?.length ? props.rfiAnswers?.length : 0}/
            {
              props.sectionTemplate?.rfi3_questions?.filter(
                (q) =>
                  q.type !== SECTION_INLINE_HEADER &&
                  q.type !== QUESTION_TYPE_UPLOAD,
              ).length
            }
          </span>
        )}
      </Input.Label>
      <div className="hc8-pv-3x">{renderAllQuestions()}</div>
    </div>
  )
}

export default RFI3QuestionWindow
